import script from "./PropertySummaryCard.vue?vue&type=script&setup=true&lang=js"
export * from "./PropertySummaryCard.vue?vue&type=script&setup=true&lang=js"

import "./PropertySummaryCard.vue?vue&type=style&index=0&id=7525af2b&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7525af2b"]])

export default __exports__